import { styled } from "@mui/material";

const DialogBody = styled("div")`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  row-gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2.5)};
  text-align: center;
  flex-grow: 1;
  top: 8%;
`;

export { DialogBody };
